import moment from "moment";

/**
 * Formats any date string (YYYY-MM-DD HH:mm:ss, YYYY-MM-DDTHH:mm, YYYY-MM-DD, etc.)
 * to Czech display format: DD. MM. YYYY HH:mm:ss
 * Returns "—" for null/undefined/empty.
 */
export const fmtDateTime = (d) =>
    d ? moment(d).format("DD. MM. YYYY HH:mm:ss") : "—";

/**
 * Date only — DD. MM. YYYY
 */
export const fmtDate = (d) =>
    d ? moment(d).format("DD. MM. YYYY") : "—";
